import { getUser } from '.';
declare let window;
const user = getUser();

export const gtmShootEvent = (model: tagModel) => {
	const tag: any = model;
	tag.section = model.section ? kebabCase(model.section) : null;
	tag.label = model.label ? kebabCase(model.label) : null;

	if (user) {
		tag.user_Id = user.id;
	}

	window.dataLayer && window.dataLayer.push(tag);
};

const kebabCase = (str: string) => {
	return str
		.replace(/([a-z])([A-Z])/g, '$1-$2')
		.replace(/[\s_]+/g, '-')
		.toLowerCase();
};

export const getTagScreen = (route: string): string => {
	switch (route) {
		case '/general':
			return tagScreenEnum.COLLABORATOR_DASHBOARD;
		case '/simulation':
			return tagScreenEnum.COLLABORATOR_ORDER_STEP_1;
		case '/documents':
			return tagScreenEnum.COLLABORATOR_ORDER_STEP_2;
		case '/documents/confirmation':
			return tagScreenEnum.COLLABORATOR_ORDER_STEP_3;
		case '/documents/status':
			return tagScreenEnum.COLLABORATOR_ORDER_SUCCESS;
		case 'loans/details':
			return tagScreenEnum.COLLABORATOR_ORDER_DETAIL;
		default:
			return '';
	}
};

export enum tagScreenEnum {
	COLLABORATOR_HOME_PAGE = 'tomador-pagina-inicial',
	COLLABORATOR_DEBT_PURCHASE_PAGE = 'tomador-compra-de-divida',
	COLLABORATOR_ERROR_PAGE = 'tomador-pagina-erro',
	COLLABORATOR_SUCCESS_PAGE = 'tomador-pagina-de-sucesso',
	COLLABORATOR_CPF_EXIST = 'tomador-pagina-cpf-existente-na-base-cadastro',
	COLLABORATOR_REGISTER_SUCCESS = 'tomador-pre-cadastro-com-sucesso',
	COLLABORATOR_LOGIN = 'tomador-pagina-de-login',
	COLLABORATOR_RESET_PASSWORD = 'tomador-pagina-redefinicao-de-senha',
	COLLABORATOR_DASHBOARD = 'tomador-dashboard-inicial',
	COLLABORATOR_ORDER_STEP_1 = 'tomador-proposta-passo-1',
	COLLABORATOR_ORDER_STEP_2 = 'tomador-proposta-passo-2',
	COLLABORATOR_ORDER_STEP_3 = 'tomador-proposta-passo-3',
	COLLABORATOR_ORDER_SUCCESS = 'tomador-proposta-sucesso',
	COLLABORATOR_ORDER_DETAIL = 'tomador-proposta-detalhe',
	COLLABORATOR_CANCEL_ORDER = 'tomador-cancelamanto-proposta',
	COLLABORATOR_USER_DATA = 'tomador-dados-cadastrais',
	COLLABORATOR_CCB = 'cedula-de-credito-bancario',
}

export enum tagSectionEnum {
	DETAIL_YOUR_LOAN = 'detalhes-de-seu-empréstimo',
	ANALYSIS_LOAN = 'emprestimos-em-analise',
	SAVE_ORDER = 'propostas-salvas',
	REQUEST_YOUR_LOAN = 'solicite-o-seu-emprestimo-consignado',
	PERSONAL_DATA = 'dados-pessoais',
	CONTACT_DATA = 'dados-de-contato',
	BANK_DATA = 'dados-bancarios',
	ADDRESS_USER = 'endereco-residencial',
	CONTRACT_LOAN = 'contrato-de-emprestimo-consignado',
	DOCUMENTS_DETAILS_LOAN = 'sessão-documentos',
	EXTRACTS_LOAN = 'sessão-movimentação',
}

export interface tagModel {
	screen: string;
	section: string | null;
	label: string | null;
	payload: string | null;
}
